<template>
  <InputLabel :label="label" :tooltip="tooltip" :is-error="isError" :warning="warning">
    <textarea
      ref="textarea"
      :rows="rows ?? initialRows ?? 2"
      :disabled="disabled"
      :value="inputText"
      :class="input({ size: 'sm' })"
      :placeholder="placeholder"
      v-bind="events"
      @input="$emit('update:inputText', ($event.target as HTMLTextAreaElement).value)"
    ></textarea>
    <InputHint :hint="hint" :is-error="isError" />
  </InputLabel>
</template>

<script lang="ts" setup>
import { computed, ref, useAttrs, watch } from 'vue';
import InputLabel from './InputLabel.vue';
import InputHint from './InputHint.vue';
import { input } from '@carvia/theme/lib/cva/input';

const props = defineProps<{
  name?: string;
  label?: string;
  placeholder?: string;
  hint?: string;
  inputText?: string | number | null;
  disabled?: boolean;
  isError?: boolean;
  rows?: number | string;
  tooltip?: string;
  warning?: string;
  initialRows?: number;
}>();

defineEmits<{
  (e: 'update:inputText', inputText: string): void;
}>();

const textarea = ref<HTMLTextAreaElement>();

const attrs = useAttrs();
const events = computed(() =>
  Object.fromEntries(Object.entries(attrs).filter(([key]) => key.startsWith('on'))),
);

watch([textarea, () => props.inputText], () => {
  if (textarea.value) {
    textarea.value.style.height = 'auto';
    textarea.value.style.height = `${textarea.value.scrollHeight + 2}px`;
  }
});

const inputText = computed(() => (props.inputText !== null ? props.inputText : undefined));
</script>
